module.exports = __webpack_public_path__ + "db25ee0bdedd372f523ae8893220d6b4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-folders/create/create-shared-folder.html
// module id = 1891
// module chunks = 0